module.exports = __webpack_public_path__ + "img/download_pc.21bbd7e3.png";